import React from 'react';
import Link from './TrackedLink';
import renderHTML from 'react-render-html';

const BreadcrumbItem = ({ path, label, position }) => {
	return (
		<li
			className="breadcrumb-item"
			itemProp="itemListElement"
			itemScope
			itemType="http://schema.org/ListItem"
		>
			{
				path !== undefined ? (
					<Link to={ path } itemProp="item">
						<span itemProp="name">{ renderHTML(label) }</span>
					</Link>
				) : <span itemProp="name">{ renderHTML(label) }</span>
			}
			{
				position !== undefined ? <meta itemProp="position" content={position} /> : null
			}
		</li>
	);
};

export default BreadcrumbItem;


// WEBPACK FOOTER //
// ./src/pages/common/BreadcrumbItem.js